export { default } from "./useReportContent";
